<template>

  <div class="page">
    <div class="title">
      <span><img src="../../assets/new/back.png"
             alt=""
             @click="goBack" /></span>
      <span class="ti">详情</span>
      <span style="display: inline-block; width: 20px"></span>
    </div>
    <!-- 图片 -->
    <div class="group_1">
      <img :src="classInfo.classImage"
           alt=""
           v-if="classInfo.classImage != ''&&classInfo.classImage !=null" />
      <img src="../../assets/new/bigBg.png"
           alt=""
           v-if="classInfo.classImage == ''||classInfo.classImage ==null" />

    </div>
    <div class="group_2">
      <div class="text_1">
        {{ classInfo.className }}
      </div>
      <div style="display: flex; margin-top: 8px">
        <span class="text_2"> {{ classInfo.classCodeName }}</span><span class="text_2">{{ classInfo.classCredithour
            }}学时</span>
        <!-- <span class="text_2">继续教育</span> -->
      </div>
      <div class="text_3"
           style="margin-top: 8px">培训方式：{{ classInfo.classType == '01' ? '在线' : classInfo.classType ==
          '02' ? '面授' : '混合' }}</div>
      <div class="text_3">报名时间：{{ classInfo.classStarttime }} - {{ classInfo.classEndtime }}</div>
      <div class="text_3">上课时间：{{ classInfo.classEnrolStarttime }} - {{ classInfo.classEnrolEndtime }}</div>
    </div>
    <!-- 课程介绍 -->
    <div class="group_3">
      <div class="title_1">
        <span class="block"></span> <span class="text_4">课程介绍</span>
      </div>
      <div class="box_1"
           v-if="classInfo.classDescContent1 && classInfo.classDescTitle1">
        <div class="title_2"
             style="margin-bottom: 10px">{{ classInfo.classDescTitle1 }}</div>
        <div class="text_5">
          {{ classInfo.classDescContent1 }}
        </div>
      </div>
      <div class="box_2" v-if="classInfo.classDescContent2 && classInfo.classDescTitle2">
        <div >
          <div class="title_2"
               style="margin-bottom: 10px">{{ classInfo.classDescTitle2 }}</div>
          <div class="text_5">
            {{ classInfo.classDescContent2 }}
          </div>
        </div>
        <div style="margin-top: 30px; padding: 0 17px">
          <div v-if="classInfo.classDescContent3 && classInfo.classDescTitle3">
            <div class="section_1">
              <div class="title_3">{{ classInfo.classDescTitle3 }}</div>
              <div class="text_6">
                {{ classInfo.classDescContent3 }}
              </div>
            </div>
            <div class="jiantou">
              <img src="../../assets/new/bottom (2).png"
                   alt="" />
            </div>
          </div>
          <div v-if="classInfo.classDescContent4 && classInfo.classDescTitle4">
            <div class="section_1">
              <div class="title_3">{{ classInfo.classDescTitle4 }}</div>
              <div class="text_6">
                {{ classInfo.classDescContent4 }}
              </div>
            </div>
            <div class="jiantou">
              <img src="../../assets/new/bottom (2).png"
                   alt="" />
            </div>
          </div>
          <div v-if="classInfo.classDescContent5 && classInfo.classDescTitle5">
            <div class="section_1">
              <div class="title_3">{{ classInfo.classDescTitle5 }}</div>
              <div class="text_6">
                {{ classInfo.classDescContent5 }}
              </div>
            </div>
            <div class="jiantou">
              <img src="../../assets/new/bottom (2).png"
                   alt="" />
            </div>
          </div>
          <div class="section_1"
               v-if="classInfo.classDescContent6 && classInfo.classDescTitle6">
            <div class="title_3">{{ classInfo.classDescTitle6 }}</div>
            <div class="text_6">
              {{ classInfo.classDescContent6 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程目录 -->
    <div class="group_4"
         id="contents">
      <div class="title_1"
           style="margin-bottom: 16px">
        <span class="block"></span> <span class="text_4">课程目录</span>
      </div>
      <div v-if="courseList.length > 0">
        <div v-for="(item1, index) in courseList"
             :key="index"
             style="margin-bottom: 10px;">
          <div class="section_2"
               v-show="!isExpanded(index)"
               @click="toggleExpand(index)">
            <span class="text_7">
              {{ item1.cname }}</span>
            <span class="text_8">合计{{ item1.cwSize }}章节<img src="../../assets/new/right (2).png"
                   alt="" /></span>
          </div>
          <div class="section_3"
               v-show="isExpanded(index)">
            <div class="box_3">
              <span class="text_7"
                    style="color: #2a70f2">
                {{ item1.cname }}</span>
              <span class="text_8"
                    style="color: #2a70f2"
                    @click="toggleExpand(index)">合计{{ item1.cwSize }}章节<img src="../../assets/new/jiantou.png"
                     alt="" /></span>
            </div>
            <div class="box_4"
                 v-for="(v, index1) in item1.cwList"
                 :key="v.id">
              <div style="display: flex;justify-content: space-between;"
                   v-for="h in v.chapterList"
                   :key="h.id">
                <div class="courseTitle"
                     style="margin-bottom: 10px;">
                  <div class="text_9">第{{ index1 + 1 }}章 :{{ h.chapterTitle }}</div>
                  <div class="text_10">总时长 {{ h.period }}</div>
                </div>
                <div class="btn_1"
                     @click="watch(h)"
                     v-if="index1 == 0">试看</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;"
           v-else>暂无课程</div>
    </div>
    <!-- 讲师介绍 -->
    <div class="group_5">
      <div class="title_1">
        <span class="block"></span> <span class="text_4">讲师介绍</span>
      </div>
      <div class="section_4"
           v-if="classInfo.teacherRealName">
        <div class="tearch">
          <div class="photo" style="display: flex;align-items: center;">
            <img v-if="classInfo.teacherImage"
                 :src="classInfo.teacherImage"
                 alt="" />
            <img src="../../assets/new/xiaoBg.png"
                 alt=""
                 v-if="classInfo.teacherImage == ''" />
                 <div style="margin-left: 13px">
            <div class="name">{{ classInfo.teacherRealName }}</div>
           
          </div>
         
        </div>
        <div style="display: flex;"><span class="btn_2"
            v-if="classInfo.position">{{ classInfo.position }}</span></div>
         
          </div>
        <div class="text_11" v-html="classInfo.teacherDesc">
        </div>
      </div>
      <div class="section_4"
           style="display: flex;align-items: center;justify-content: center;padding: 20px;"
           v-if="classInfo.teacherRealName == ''">暂无讲师</div>
    </div>
    <!-- 就业分析 -->
    <div class="group_6">
      <div class="title_1"
           style="margin-bottom: 16px">
        <span class="block"></span> <span class="text_4">就业分析</span>
      </div>
      <div class="section_5"
           v-if="classInfo.employAnalysisTitle1 && classInfo.employAnalysisContent1">
        <div class="title_5">
          <img src="../../assets/new/icon1.png"
               alt="" />
          <span>{{ classInfo.employAnalysisTitle1 }}</span>
        </div>
        <div class="text_12">
          {{ classInfo.employAnalysisContent1 }}
        </div>
      </div>
      <div class="section_5"
           v-if="classInfo.employAnalysisTitle2 && classInfo.employAnalysisContent2">
        <div class="title_5">
          <img src="../../assets/new/icon2.png"
               alt="" />
          <span> {{ classInfo.employAnalysisTitle2 }}
          </span>
        </div>
        <div class="text_12">
          {{ classInfo.employAnalysisContent2 }}
        </div>
      </div>
      <div class="section_5"
           v-if="classInfo.employAnalysisTitle3 && classInfo.employAnalysisContent3">
        <div class="title_5">
          <img src="../../assets/new/icon3.png"
               alt="" />
          <span> {{ classInfo.employAnalysisTitle3 }}</span>
        </div>
        <div class="text_12">
          {{ classInfo.employAnalysisContent3 }}

        </div>
      </div>
      <div class="section_5"
           v-if="classInfo.employAnalysisTitle4 && classInfo.employAnalysisContent4">
        <div class="title_5">
          <img src="../../assets/new/icon4.png"
               alt="" />
          <span> {{ classInfo.employAnalysisTitle4 }}</span>
        </div>
        <div class="text_12">
          {{ classInfo.employAnalysisContent4 }}

        </div>
      </div>
      <div class="section_5"
           v-if="classInfo.employAnalysisTitle5 && classInfo.employAnalysisContent5">
        <div class="title_5">
          <img src="../../assets/new/icon5.png"
               alt="" />
          <span> {{ classInfo.employAnalysisTitle5 }}</span>
        </div>
        <div class="text_12">
          {{ classInfo.employAnalysisContent5 }}

        </div>
      </div>
      <div class="section_5"
           v-if="classInfo.employAnalysisTitle6 && classInfo.employAnalysisContent6">
        <div class="title_5">
          <img src="../../assets/new/icon6.png"
               alt="" />
          <span> {{ classInfo.employAnalysisTitle6 }}</span>
        </div>
        <div class="text_12">
          {{ classInfo.employAnalysisContent6 }}

        </div>
      </div>
    </div>
    <!-- 班级优势 -->
    <div class="group_7">
      <div class="title_1"
           style="margin-bottom: 16px;">
        <span class="block"></span> <span class="text_4">班级优势</span>
      </div>
      <div class="section_6">
        <div class="text_13">线上教学</div>
        <div class="text_14"> <span style="display: inline-block;width: 214px;
height: 38px;">学习时间空间不受限，可根据自身实际灵活学习。</span></div>
      </div>
      <div class="section_6">
        <div class="text_13"
             style="background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/22/ahsjxjy-New-WebApi_1745309571728.png');">
          多模式讲师</div>
        <div class="text_14"
             style=" background: rgba(248,132,65,0.1);"> <span style="display: inline-block;width: 214px;
height: 38px;">采用多重讲授模式，帮助学员扩充知识，举一反三。</span></div>
      </div>
      <div class="section_6">
        <div class="text_13"
             style="background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/22/ahsjxjy-New-WebApi_1745309601508.png');">
          实操技能</div>
        <div class="text_14"
             style="background: rgba(234,87,89,0.1);"> <span style="display: inline-block;width: 214px;
height: 38px;">结合实际工作需要，定向培养建模组价实用性技能。</span></div>
      </div>
    </div>
    <!-- 学员评价 -->
    <div class="group_8">
      <div class="title_1"
           style="margin-bottom: 16px;">
        <span class="block"></span> <span class="text_4">学员评价</span>
      </div>
      <div v-if="evaluateList.length > 0">
        <div class="section_7"
             v-for="w in evaluateList"
             :key="w.id">
          <div class="studentInfo">
            <div style="display: flex;">
              <img :src="w.userPhoto"
                   alt="">
              <div>
                <div class="text_19">{{ w.userName }}</div>
                <div class="text_17">{{ w.mobile }}</div>

              </div>
            </div>
            <div class="time">{{ w.createTime }}</div>
          </div>
          <div class="text_15">{{ w.content }}</div>
        </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;"
           v-else> 暂无评价</div>
    </div>
    <!-- 购买指南 -->
    <div class="group_9"
         style="padding-bottom: 157px;">
      <div class="title_1"
           style="margin-bottom: 16px;">
        <span class="block"></span> <span class="text_4">购买指南</span>
      </div>
      <div class="section_8">
        <div class="btn_4">课程有效期</div>
        <div class="text_16">①365天:该产品课程有效期为自购课之日起，满365天(自然日)为止截止。</br>
          ②课程有效期过后，课程/资料(含已下载)将失效，请您按时进行课程学习。</div>
        <div class="btn_4">支付方式</div>
        <div class="text_16">支持微信、支付宝在线支付和银行对公转账汇款。</div>
        <div class="btn_4">联系电话</div>
        <div class="text_16">客服电话400-8816-822（周一至周五8:30-12:00/14:00-17:30）</div>
        <div class="btn_4">版权提醒</div>
        <div class="text_16">①平台官网/APP所有课程(包括:会员功能/题库内容/其他产品)著作权均为公司所有。</br>
          ②平台账号仅限用户本人使用，请您妥善保护自己的平台账号，凡是倒卖账号、未经授权对平台任何课程进行录播并进行销售或将 平台课程用于其他商业目的的行为，一经发现，平台 将有权进行封号处理。</div>
      </div>
    </div>
    <!-- 购买按钮 -->
    <div class="group_10">
      <div class="text_18" v-if="classInfo.isClassApply=='02'">
        <span style="font-size: 14px;color: #FF6632;" >￥</span> {{ classInfo.classPrice.toFixed(1)||0 }}</div>
        <div class="text_18" v-if="classInfo.isClassApply=='01'" >
          <span style="font-size: 14px;color: #FF6632;" >￥</span> 
          {{ classInfo.creditPrice||0 }} <span style="color: #FF6632;font-size: 14px;">/学时</span></div>
      <div class="btn_5"
           @click="tableHandel"  v-if="classInfo.classEnrolStatus=='02'">免费试看</div>
      <div class="btn_6"
           @click="toPay(classInfo)" v-if="classInfo.classEnrolStatus=='02'">立即购买</div>

    </div>
    <!-- 有订单弹框 -->
    <div class="pool"></div>
    <div class="delete_order_box">
      <div class="delete_order">
        <p class="delete_warn">您有未支付订单，不能再次报名，请前往学习中心的缴费订单模块处理，
          是否现在处理?</p>
        <button class="cancle"
                @click="cancleControlOrder">取消</button>
        <button class="ensure"
                @click="ensureCancleOrder">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
// import config from "@/api/base.js";
import {toClassDetailByPx,toClassIsBuy,toGeneratePxOrder,toZyPxClassDetail} from '../../api/zyDetail';
import { toGenerateOrder } from '../../api/classDetail';

export default {
  data () {
    return {
      classInfo: {},
      courseList: [],
      evaluateList: [],
      classId:'',
      expandedStates: [],// 用于存储每个课程项的展开状态
    };
  },
  created () {
    this.getDetail()
  }
  , mounted () { },
  methods: {
    // 返回上一页
    goBack () {
      this.$router.go(-1);
    },
    //获取详情
    getDetail () {
      var _this = this
      const params = {
        classId: this.$route.query.classNo
      }
      toZyPxClassDetail(params).then( res=> {
          _this.classInfo = res.data.data
          _this.courseList = res.data.data.classCourseList
          console.log(_this.classInfo,'888');
          
          _this.evaluateList = res.data.data.evaluateList.rows
          _this.classId=res.data.data.classId
        });
    },
    // 课程展开关闭
    isExpanded (index) {
      return this.expandedStates[index];
    },
    toggleExpand (index) {
      this.$set(this.expandedStates, index, !this.expandedStates[index]);

    },
    //试听
    tableHandel () {
      document.getElementById('contents').scrollIntoView({ behavior: 'smooth' });
      this.$set(this.expandedStates, 0, true);
    },
    //去购买
    toPay (classInfo) {
      console.log(classInfo);
      
       const data = {
          classId: classInfo.classId,
          courseIds: '',
          // derateType:'',
           equipment:'02'
        };
        toGenerateOrder(data).then(res => {
        if (res.data.data.result == 0) {
          //创建订单失败返回信息
          this.$utils.showToast(res.data.data.msg);
          return false;
        }
         if (res.data.data.result == 1) {
          //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
          let data = res.data.data.order;
          this.$router.push({
            path: '/payType',
            query: data
          });
        }
        //已有订单
        if (res.data.data.result == 3) {
          this.balanceShow = false;
          Dialog.confirm({
            title: '温馨提示',
            message: res.data.data.msg,
            confirmButtonColor: '#2A70F2'
          })
            .then(() => {
              this.$router.push('/myOrder');
            })
            .catch(() => {
              // this.$utils.showToast('用户点击了取消');
            });
          return false;
        }
        });
    },
       // 弹框点击确定
       ensureCancleOrder() {
      this.$router.push("/orderList");
    },
    // 弹框点击取消
    cancleControlOrder() {
      $(".pool,.delete_order_box").fadeOut();
    },
    //跳试看页
    watch(item){
 this.$router.push({
              path: '/tryPlaying',
              query:{
                id:item.cwId,
                name:item.chapterTitle,
                isZYPX:'02'
              }
            });
    },
 
  },
};
</script>

<style scoped>
.page {
  background-color: #f6f8fa;
  height: 100vh;
}

.title {
  padding: 20px 15px 13px 15px;
  display: flex;
  justify-content: space-between;
  position: fixed;
    z-index: 99;
    width: 100%;
    background-color: #fff;
    top: 0;
    height: 55px;
}

.title img {
  width: 18px;
  height: 18px;
}

.ti {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333333;
}

.group_1 {
  /* width: 375px; */
  height: 300px;
  margin-top: 15px;
}

.group_1 img {
  width: 100%;
  height: 300px;
}

.group_2 {
  /* width: 375px; */
  /* height: 170px; */
  background: #ffffff;
  padding: 20px 15px;
  margin-bottom: 10px;
}

.text_1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  /* width: 286px; */
  /* display: -webkit-box; */
  /* 使用弹性盒模型 */
  /* -webkit-box-orient: vertical; */
  /* 垂直排列子元素 */
  -webkit-line-clamp: 1;
  /* 限制显示的行数为2行 */
  /* overflow: hidden; */
}

.text_2 {
  padding: 4px 5px;
  height: 24px;
  background: rgba(42, 112, 242, 0.1);
  border-radius: 4px 4px 4px 4px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #2a70f2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.text_3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  margin-top: 6px;
}

.group_3 {
  /* width: 375px; */
  background: #ffffff;
  padding: 20px 15px;
  margin-bottom: 10px;
}

.block {
  width: 4px;
  height: 16px;
  background: #2a70f2;
  border-radius: 0px 0px 0px 0px;
  display: inline-block;
  margin-right: 8px;
}

.title_1 {
  display: flex;
  align-items: center;
}

.text_4 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333333;
}

.box_1 {
  /* width: 345px; */
  background: #f6f9fc;
  border-radius: 8px 8px 8px 8px;
  margin-top: 12px;
  padding: 20px 15px;
}

.title_2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 15px;
  color: #2a70f2;
}

.text_5 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.box_2 {
  /* width: 345px; */
  background: #f6f9fc;
  border-radius: 8px 8px 8px 8px;
  margin-top: 12px;
  padding: 20px 15px;
}

.section_1 {
  /* width: 280px; */
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f3f3f3;
}

.title_3 {
  /* width: 280px; */
  height: 48px;
  background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
  border-radius: 10px 10px 0px 0px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_6 {
  padding: 16px 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #656e7e;
}

.jiantou {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jiantou img {
  width: 60px;
  height: 30px;
}

.group_4 {
  /* width: 375px; */
  background: #ffffff;
  padding: 20px 15px;
  margin-bottom: 10px;
}

.section_2 {
  /* width: 345px; */
  height: 62px;
  background: #f2f5f8;
  border-radius: 6px 6px 6px 6px;
  padding: 21px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.group_5,
.group_6,
.group_7,
.group_8,
.group_9 {
  /* width: 375px; */
  background: #ffffff;
  padding: 20px 15px;
  margin-bottom: 10px;
}

.group_9 {
  height: 660px;
}

.text_7 {
  width: 182px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  display: -webkit-box;
  /* 使用弹性盒模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列子元素 */
  -webkit-line-clamp: 1;
  /* 限制显示的行数为2行 */
  overflow: hidden;
}

.text_8 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  display: flex;
  align-items: center;
}

.text_8 img {
  width: 14px;
  height: 14px;
}

.section_3 {
  /* width: 345px; */
  background: rgba(42, 112, 242, 0.1);
  border-radius: 6px 6px 6px 6px;
  padding: 20px 15px;
}

.box_3 {
  display: flex;

  justify-content: space-between;
}

.box_4 {
  /* display: flex;
  justify-content: space-between; */
  margin-top: 10px;
}

.text_9 {
  width: 182px;
  display: -webkit-box;
  /* 使用弹性盒模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列子元素 */
  -webkit-line-clamp: 1;
  /* 限制显示的行数为2行 */
  overflow: hidden;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #444444;
}

.text_10 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 4px;
}

.btn_1 {
  width: 72px;
  height: 36px;
  background: rgba(42, 112, 242, 0.2);
  border-radius: 20px 20px 20px 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2a70f2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section_4 {
  margin-top: 16px;
  /* width: 345px; */
  /* height: 300px; */
  background: rgba(64, 118, 246, 0.1);
  border-radius: 6px 6px 6px 6px;
  background-repeat: no-repeat;
  /* background-size: 100%; */
  padding: 34px 15px 30px 15px;
  background-image: url("https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/22/ahsjxjy-New-WebApi_1745309027614.png");
}

.photo img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.tearch {
  /* display: flex; */
}

.name {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
}

.btn_2 {
  width: auto;
  margin-top: 5px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 13px;
  padding: 0 10px;
  color: #ffffff;
  display: flex;
  line-height: 30px;
  height: 30px;
  background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
  border-radius: 15px 15px 15px 15px;
}

.text_11 {
  margin-top: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #444444;
}

.section_5 {
  /* width: 345px; */
  margin-bottom: 10px;
  padding: 23px 15px;
  background: #f2f5f8;
  border-radius: 6px 6px 6px 6px;
}

.title_5 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 15px;
  color: #333333;
  display: flex;
  align-items: center;
}

.title_5 img {
  width: 20px;
  margin-right: 9px;
  height: 20px;
}

.text_12 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #656e7e;
  margin-top: 12px;
}

.section_6 {
  position: relative;
  margin-bottom: 16px;

}

.text_13 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  width: 103px;
  position: absolute;
  top: -7px;
  left: 0;
  height: 50px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  background-repeat: no-repeat;
  background-size: 100%;
  background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/22/ahsjxjy-New-WebApi_1745309099123.png');
}

.text_14 {
  margin-left: 44px;
  /* width: 301px; */
  height: 55px;
  background: rgba(66, 148, 246, 0.1);
  border-radius: 10px 10px 10px 10px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 14px;
  padding-left: 72px;
  display: flex;
  align-items: center;
  color: #555555;
}

.section_7 {
  border-bottom: 1px solid #EEEEEE;
  margin-bottom: 24px;
}

.studentInfo {
  display: flex;
  justify-content: space-between;

}

.studentInfo img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 8px;
}

.text_15 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #444444;
  margin-top: 10px;
  padding-bottom: 24px;
}

.time {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
}

.text_19 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.text_17 {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}


.btn_4 {
  width: 100px;
  height: 32px;
  background: #2A70F2;
  border-radius: 19px 19px 19px 19px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 32px;
  text-align: center;
  margin-bottom: 10px;
}

.text_16 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  margin-bottom: 32px;
}

.group_10 {
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  padding: 10px 15px;

}

.text_18 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 22px;
  width:129px;
  color: #FF6632;
  display: flex;
  align-items: center;
  /* margin-right: 60px; */
}

.btn_5 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  width: 110px;
  margin-right: 10px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(90deg, #6996FF 0%, #4093F6 100%);
  border-radius: 8px 8px 8px 8px;
}

.btn_6 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(90deg, #FF8285 0%, #E74F52 100%);
  border-radius: 8px 8px 8px 8px;
  color: #FFFFFF;
}
.pool {
  position: fixed;
  top: 15px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.6;
  z-index: 2000;
  display: none;
}
.delete_order_box {
  position: fixed;
  top:15px;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  z-index: 3000;
  font-size: 16px;
  display: none;
}
.delete_order {
  height: 2.8rem;
  position: absolute;
  top: 50%;
  margin-top: -1.4rem;
  background: #fff;
  width: 250px;
  left: 16%;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -o-border-radius: 10px;
}
.delete_warn {
  height: 109px;
  line-height: 32px;
  font-size: 14px;
  padding: 10px;
}
.delete_order button {
  width: 50%;
  height: 35px;
  line-height: 0.8rem;
  border: 0;
  float: left;
  background: #fff;
  border-top: 1px solid #eee;
  font-size: 16px;
}
.cancle {
  border-right: 1px solid #eee !important;
  border-bottom-left-radius: 10px;
  -moz-border-bottom-left-radius: 10px;
  -webkit-border-bottom-left-radius: 10px;
  -o-border-bottom-left-radius: 10px;
}
.ensure {
  border-bottom-right-radius: 10px;
  -moz-border-bottom-right-radius: 10px;
  -webkit-border-bottom-right-radius: 10px;
  -o-border-bottom-right-radius: 10px;
}
</style>
